(function() {
  function alignHeader() {
    var headerCol = document.querySelector('.header__column--left');
    var heading = document.querySelector('h1');

    if (headerCol) headerCol.style.opacity = '1';

    if (headerCol && heading && heading.textContent.indexOf('NICOLE') !== -1) {
      var h1Left = heading.getBoundingClientRect().left;
      headerCol.style.marginLeft = '0';
      var colLeft = headerCol.getBoundingClientRect().left;
      var margin = (h1Left - colLeft - 30);
      headerCol.style.marginLeft = margin + 'px';
      localStorage.setItem('headerMargin', margin);
    } else if (headerCol) {
      var saved = localStorage.getItem('headerMargin');
      headerCol.style.marginLeft = saved ? saved + 'px' : '80px';
    }
  }

  document.addEventListener('DOMContentLoaded', alignHeader);
  window.addEventListener('resize', alignHeader);
})();
(function () {
  function alignHeaderRight() {
    var right = document.querySelector('.header__column--right');
    var text = document.querySelector(
      '.text-block--AYlVkOGFUMVEzYXVXc__text_QKPDHb'
    );

    if (!right) return;
    right.style.removeProperty('translate');

    // Mobile Anordnung und Seiten ohne diesen Textblock unverändert lassen.
    if (window.innerWidth < 750 || !text) return;

    var icons = right.querySelectorAll('svg');
    var lastIcon = icons[icons.length - 1];
    if (!lastIcon) return;

    var textRight = text.getBoundingClientRect().right;
    var iconRight = lastIcon.getBoundingClientRect().right;

    right.style.translate = (textRight - iconRight) + 'px 0';
  }

  window.addEventListener('load', alignHeaderRight);
  window.addEventListener('resize', alignHeaderRight);
  document.addEventListener('DOMContentLoaded', alignHeaderRight);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(alignHeaderRight);
  }
})();